/**
 * This regular expression is equivalent to the `VALID_EMAIL_REG_EXP` defined in
 * app/models/valid_email.rb, which we use to validate the email address in the User model.
 *
 * I've made the RegExp case-sensitive so that we can use its `source` property directly as the
 * value for the `pattern` attribute of the `emailValid` validation rule in
 * `app/javascript/src/features/registration/validation_rules.js`.
 * The `pattern` attribute expects a string, not a RegExp object, and it does not support
 * case-insensitive matching.
 *
 */
const mailbox =  "[a-zA-Z0-9_.&%+\\-']+";
const subdomains = "(?:[a-zA-Z0-9\\-]+\\.)+";
const tld = "(?:[a-zA-Z]{2,25})";
export default new RegExp(`^${mailbox}@${subdomains}${tld}$`)
